import { render, staticRenderFns } from "./GeneralConditions.vue?vue&type=template&id=4792be54&"
import script from "./GeneralConditions.vue?vue&type=script&lang=js&"
export * from "./GeneralConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports